import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import Swal from "sweetalert2";

export default function ContactForm() {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        full_name: "",
        email: "",
        phone_number: "",
        message: "",
    });
    UseScrollAnimation();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch("https://ligasos-laravel.ligasos.co/api/contact", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (response.ok) {
                Swal.fire({
                    title: t("Success!"),
                    text: t("Message sent successfully"),
                    icon: "success",
                    confirmButtonText: t("OK"),
                });
                setFormData({
                    full_name: "",
                    email: "",
                    phone_number: "",
                    message: "",
                }); // Clear form
            } else {
                Swal.fire({
                    title: t("Error"),
                    text: t(result.message || "Something went wrong"),
                    icon: "error",
                    confirmButtonText: t("OK"),
                });
            }
        } catch (error) {
            Swal.fire({
                title: t("Error"),
                text: t("Failed to connect to the server"),
                icon: "error",
                confirmButtonText: t("OK"),
            });
        }
    };

    return (
        <section className="relative py-[40px]">
            <div className="container">
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-col gap-[15px]">
                        <div className="f-col flex gap-[20px]">
                            <div className="w-100 w-[48%]">
                                <div className="flex flex-col gap-[7px]">
                                    <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">{t("Full Name")}</label>
                                    <input
                                        className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]"
                                        name="full_name"
                                        type="text"
                                        placeholder={t("Full Name")}
                                        value={formData.full_name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="flex flex-col gap-[7px]">
                                    <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">{t("Email")}</label>
                                    <input
                                        className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]"
                                        name="email"
                                        type="email"
                                        placeholder={t("Email")}
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="flex flex-col gap-[7px]">
                                    <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">{t("Phone Number")}</label>
                                    <input
                                        className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]"
                                        name="phone_number"
                                        type="text"
                                        placeholder={t("Phone Number")}
                                        value={formData.phone_number}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="w-100 w-[48%] flex flex-col gap-[7px]">
                                <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">{t("Message")}</label>
                                <textarea
                                    name="message"
                                    className="h-250 h-full max-h-[350px] js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]"
                                    placeholder={t("Message")}
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                ></textarea>
                            </div>
                        </div>
                        <button
                            type="submit"
                            className="js-scroll fade-btm w-fit bg-[#132A40] text-white px-[40px] py-[8px] rounded font-bold capitalize"
                        >
                            {t("send")}
                        </button>
                    </div>
                </form>
            </div>
        </section>
    );
}